<template>
  <div class="content">
    <!-- h5 -->
    <div class="h5" v-if="screenList == 'noPc'">
      <!-- <img src="../image/zero.png" alt="" class="number" /> -->
      <div class="header one">
        <div class="title">高地蜂米粒 · 线上物业服务平台</div>
        <div class="tip md">智慧社区 从此开始</div>

        <div
          v-if="Android != null"
          style="text-align: center; display: flex; justify-content: center"
          @click="appSource"
          v-log="['下载', channel]"
        >
          <img src="../image/android.png" class="android" />
        </div>

        <div
          v-if="ios != null"
          style="text-align: center; display: flex; justify-content: center"
          @click="appSource"
          v-log="['下载', channel]"
        >
          <img src="../image/ios.png" class="ios android" />
        </div>
      </div>
      <div class="center">
         <!-- <img src="../image/onePcImg.png" alt="" class="number" /> -->
        <img src="../image/two.png" alt="" class="number" />
        <img src="../image/three.png" alt="" class="number" />
        <img src="../image/four.png" alt="" class="number" />
        <img src="../image/five.png" alt="" class="number" />
      </div>
      <div class="footer">
        <div class="footerBox footerOne">
          <img src="../image/wxCode.png" alt="" class="wxCode" />
        </div>
        <div class="footerBox footerTwo">
          <span class="service">服务热线</span>
          <span class="tel">400-1510-099</span>
        </div>
        <div class="footerBox footerThree">
          <span @click="goWebsite" class="hand"> {{searchVal?'沪ICP备2021010224号-1':'沪ICP备 17038144 号'}}</span>&nbsp;&nbsp;&nbsp;
          <div>{{searchVal?'上海蜂高科技有限公司':'上海高地物业管理有限公司'}}</div>
           
        </div>
      </div>
      <div class="btn" v-show="list">
        <div
          @click="appSource"
          class="goAuthentication"
          hover-class="none"
          hover-stop-propagation="false"
          v-log="['下载', channel]"
        >
          立刻下载
        </div>
      </div>
    </div>
    <!-- pc -->
    <div class="pc" v-if="screenList == 'pc'">
      <div class="pcOne">
        <div class="pcDiv clearfix">
          <img :src="erweima" class="erweima fl" />
          <div class="fl">
            <div class="btnImg" @click="btnimg" data-index="1">
              <img
                :src="
                  active == 1
                    ? 'https://golte-platform.oss-cn-shanghai.aliyuncs.com/app/common/androidTwo.png'
                    : 'https://golte-platform.oss-cn-shanghai.aliyuncs.com/app/common/android.png'
                "
                class="android"
                :class="active == 1 ? 'sting' : ''"
              />
            </div>
            <div class="btnImg" @click="btnimg" data-index="2">
              <img
                :src="
                  active == 2
                    ? 'https://golte-platform.oss-cn-shanghai.aliyuncs.com/app/common/iosTwo.png'
                    : 'https://golte-platform.oss-cn-shanghai.aliyuncs.com/app/common/ios.png'
                "
                class="android m0"
                :class="active == 2 ? 'sting' : ''"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <img src="../image/pcTwo.png" class="pcNumber" />
        <!-- <img src="../image/pcTwo.png" class="pcNumber" /> -->
        <img src="../image/pcThree.png" class="pcNumber" />
        <img src="../image/pcFour.png" class="pcNumber" />
        <img src="../image/pcFive.png" class="pcNumber" />
      </div>
      <div class="pcFooter">
        <!-- <img src="../image/pcSix.png" class="pcSix" /> -->
        <div class="pcSix footerBox footerThree">
          <div class="hand" @click="goWebsite">{{searchVal?'沪ICP备2021010224号-1':'沪ICP备 17038144 号'}}</div>&nbsp;&nbsp;&nbsp;
          <div>{{searchVal?'上海蜂高科技有限公司':'上海高地物业管理有限公司'}}</div>
        </div>
        <img src="../image/wxCode.png" class="wxPcCode" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",

  data() {
    return {
      erweima:
        "https://golte-platform.oss-cn-shanghai.aliyuncs.com/app/common/appCode.png",
      list: false,
      channel: "",
      Android: null,
      ios: null,
      active: 1,
      screenList: "",
      searchVal:false
    };
  },
  created() {},
  mounted() {
    var host = window.location.hostname
   
   this.searchVal = host.includes('xstarlife')
   console.log(this.searchVal)
    if (window.matchMedia("(max-width: 767px)").matches) {
      this.screenList = "noPc";
    } else {
      this.screenList = "pc";
    }
    // 已更换小程序头像logo，由于数据同步延迟的原因，需要4个小程序左右才可以同步。
    window.addEventListener("scroll", this.handleScrollx, true);
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    if (isiOS) {
      this.ios = isiOS;
    }
    if (isAndroid) {
      this.Android = isAndroid;
    }
  },
  methods: {
    handleScrollx() {
      if (window.pageYOffset > 300) {
        this.list = true;
      } else {
        this.list = false;
      }
    },
    //去域名管理系统
    goWebsite(){
      window.open('https://beian.miit.gov.cn/#/');    
    },
    // 按钮点击
    btnimg(e) {
      this.active = e.currentTarget.dataset.index;
      if (this.active == 1) {
        this.erweima =
          "https://golte-platform.oss-cn-shanghai.aliyuncs.com/app/common/appCode.png";
      } else {
        this.erweima =
          "https://golte-platform.oss-cn-shanghai.aliyuncs.com/app/common/appCode.png";
      }
    },
    appSource() {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      var agent = navigator.userAgent.toLowerCase();
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);

      if (isWeixin) {
        if (isAndroid) {
          window.location =
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.golte.starlife";
          this.channel = "Android下载";
        }
        if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
          window.location =
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.golte.starlife";
          this.channel = "Android下载";
        }
        if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
          window.location =
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.golte.starlife";
          this.channel = "Android下载";
        }
        if (isiOS) {
          window.location = "https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.golte.starlife";
          this.channel = "ios下载";
        }
        if (isMac) {
          window.location = "https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.golte.starlife";
          this.channel = "ios下载";
        }
      } else {
        if (isiOS) {
          // this.$toast("暂未上线 敬请期待");
          window.location =
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.golte.starlife";
          this.channel = "ios下载";
        }
        if (isAndroid) {
          window.location =
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.golte.starlife";
          this.channel = "Android下载";
        }
        if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
          window.location =
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.golte.starlife";
          this.channel = "Android下载";
        }
        if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
          window.location =
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.golte.starlife";
          this.channel = "Android下载";
        }
        if (isMac) {
          window.location = "https://a.app.qq.com/o/simple.jsp?pkgname=com.fosun.golte.starlife";

          this.channel = "ios下载";
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* .pc */
.pcheader {
  width: 100%;
  height: 0.6rem;

  padding: 0 2.6rem;
  box-sizing: border-box;
  line-height: 0.6rem;
}
.logoTwo {
  width: 0.3rem;
  height: 0.3rem;
  margin-right: 0.12rem;
  vertical-align: middle;
}
.pcheader .left {
  width: 50%;
  height: 0.6rem;
  line-height: 0.6rem;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.pcheader .right {
  width: 50%;
  height: 0.6rem;
  line-height: 0.6rem;
}
.pcOne {
  width: 100%;
  height: 8rem;
  background: url("https://golte-platform.oss-cn-shanghai.aliyuncs.com/app/miniapp/common/onePcImg.png")
    no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.pcNumber {
  width: 100%;
  box-sizing: border-box;
  
  display: block;
}
.pcSix {
  width: 100%;
  height: 0.8rem;
  display: block;
}
.pcFooter {
  position: relative;
}
.wxPcCode {
  width: 0.5rem;
  height: 0.5rem;
  position: absolute;
  top: 0.15rem;
  left: 66%;
  display: block;

}
/* h5 */
.h5 {
  max-width: 3.75rem;
  min-width: 100%;
  box-sizing: border-box;
}
.pcDiv {
  left: 53%;
  position: absolute;
  top: 4.03rem;
  box-sizing: border-box;

  justify-content: center;
  align-items: center;
}
.one {
  width: 100%;
  /* box-sizing: border-box;
  top:0;
  left:0;
  position:absolute; */
  height: 7.92rem;
  background: url("https://golte-platform.oss-cn-shanghai.aliyuncs.com/app/common/one.png")
    no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box; 
}
.title {
  padding-top: 1.46rem;
  text-align: center;
  font-size: 0.18rem;
  color: #ff7d41;
  font-weight: 500;
}
.tip {
  font-size: 0.15rem;
  text-align: center;
  color: #47474c;
  margin-top: 0.16rem;
  font-weight: 400;
  margin-bottom: 0.35rem;
}
.android {
  width: 1.18rem;
  height: 0.36rem;
  margin-bottom: 0.18rem;
}
.number {
  width: 100%;
  
  display: block;
  box-sizing: border-box;
}
.footer {
  height: 2.3rem;
  background-color: #fff;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}
.footerBox {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footerOne {
  margin-top: 0.13rem;
  margin-bottom: 0.13rem;
}
.wxCode {
  width: 1.06rem;
  height: 1.06rem;
}
.service {
  font-size: 0.12rem;
  color: #999;
  margin-right: 0.13rem;
  display: flex;
  align-items: center;
  height: 0.2rem;
  line-height: 0.2rem;
}
.tel {
  font-size: 0.15rem;
  color: #222;
  font-weight: 500;
}
.footerThree {
  margin-top: 0.06rem;
  color: #999;
  font-size: 0.12rem;
}
.goAuthentication {
  width: 1.48rem;
  height: 0.44rem;
  background: linear-gradient(90deg, #ffc585 0%, #ff8e55 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.16rem;
  border-radius: 1000px;
}
.btn {
  max-width: 3.75rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0.1rem;
  box-sizing: border-box;
}
.md {
  margin-bottom: 0.7rem;
}
.erweima {
  width: 1.05rem;
  height: 1.05rem;
  margin-right: 0.31rem;
}

.btnImg {
  display: flex;
}
.m0 {
  margin: 0;
}
.sting {
  box-shadow: 3px 3px 6px #888888;
}
.hand{
  cursor:pointer
}
.hand:hover{
  color:#FF7D41;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue